<template>
  <b-form-group
    :label="$t('fields.department')"
    label-for="id_departments"
  >
    <v-select
      v-model="dataItem.id_departments"
      :options="departmentList"
      label="title"
      :reduce="item => item.id"
      :placeholder="$t('fields.selectDepartment')"
      clearable
      @input="getTeams"
    />
  </b-form-group>
</template>

<script>
import { BFormGroup } from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'DepartmentsCard',
  components: { BFormGroup, vSelect },
  computed: {
    departmentList() {
      return this.$store.getters['departments/dataList']
    },
    dataItem() {
      return this.$store.getters['tasks/dataItem']
    },
  },
  created() {
    this.getDepartments()
  },
  methods: {
    getDepartments() {
      this.$store.dispatch('departments/getDataList', {
        select: ['departments.id AS id', 'departments.title AS title'],
        where: { 'departments.status': 1 },
        limit: 500,
        start: 0,
      })
    },
    getTeams() {
      this.dataItem.id_teams = null
      this.$store.dispatch('teams/getDataList', {
        select: ['teams.id AS id', 'teams.title AS title'],
        where: { 'teams.status': 1, 'teams.id_departments': this.dataItem.id_departments },
        limit: 500,
        start: 0,
      })
    },
  },
}
</script>
